'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: white;\n  text-shadow: black 2px 2px 4px;\n  font-size: 2rem;\n  align-self: flex-end;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    cursor: pointer;\n  }\n'], ['\n  color: white;\n  text-shadow: black 2px 2px 4px;\n  font-size: 2rem;\n  align-self: flex-end;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    cursor: pointer;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CloseButton = _styledComponents2.default.div(_templateObject);

exports.default = CloseButton;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/overlay/close-button.js
// module id = 1357
// module chunks = 0